<template>
	<div class="component-container" v-show="!kefuVisible">
		<div v-if="showSidebarLogin && !isLoggedIn" class="login-wrapper" @click="openLogin">
			<span class="ni-header__login-icon">
				<svg class="ni-icon ni-icon--user" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
					<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
					<circle cx="12" cy="7" r="4" />
				</svg>
			</span>
			<span class="text">{{$t('login.login')}}</span>
		</div>
		<div v-if="showCart" class="cart-wrapper" @click="toCart()">
			<span class="count">{{state.cartListCount}}</span>
			<i class="iconfont icon-gouwuche"></i>
			<span class="text">{{$t('cart1')}}</span>
		</div>
		<div ref="message" class="totop" @click="openMessage()">
			<i class="iconfont icon-zaixiankefu9 mykefu"></i>
			<span class="text">{{$t('onlineService')}}</span>
		</div>
		<div ref="totop" class="totop" @click="scrollToTop()">
			<i class="iconfont icon-fanhuidingbu"></i>
		</div>
		<div ref="tobottom" class="tobottom" @click="scrollToBottom()">
			<i class="iconfont icon-huidaodibu"></i>
		</div>
		
	</div>
	<Teleport to="body">
		<div v-if="kefuVisible" class="kefu-mask" @click.self="closeKefu">
			<div
				class="kefu-dialog"
				:class="{ 'is-full': kefuBox.fullscreen }"
				:style="kefuDialogStyle"
				role="dialog"
				aria-modal="true"
			>
				<div class="kefu-dialog__hd">
					<span>{{ $t('onlineService') }}</span>
					<button type="button" class="kefu-dialog__close" @click="closeKefu" aria-label="close">
						<i class="iconfont icon-chahao1"></i>
					</button>
				</div>
				<iframe
					v-if="kefuUrl"
					class="kefu-dialog__frame"
					:src="kefuUrl"
					title="kefu"
					allow="microphone; camera"
					@load="onKefuFrameLoad"
				></iframe>
			</div>
		</div>
	</Teleport>
</template>
<script setup>
	import { ref, provide, reactive, toRefs,
		     onBeforeMount,onMounted,onBeforeUpdate,onUpdated,onBeforeUnmount,
		     onUnmounted,onRenderTracked,onRenderTriggered,watch,computed, 
		     getCurrentInstance
		   } from 'vue';
	import { useRouter, useRoute } from 'vue-router';
    import { useStore } from 'vuex';
    import bus from 'vue3-eventbus';

    let {ctx, proxy} = getCurrentInstance();
    const router = useRouter();
	const route = useRoute();
	// console.log(route,"route-aal");

	const PHOTO_GALLERY_CART_PATHS = [
		'/topic_pic',
		'/photos',
		'/photo',
		'/gallery',
		'/weekly-pick',
		'/my/cart',
	];

	const showCart = computed(() => {
		const path = route.path || '';
		return PHOTO_GALLERY_CART_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
	});

    const props = defineProps({
	    cartCount: {
			type: Number,
			default: 0
		},
		dom:{
			type: Object,
			default: null,
		},
		showSidebarLogin: {
			type: Boolean,
			default: false,
		},
	})
	const emits = defineEmits(["scrollto"])

	const totop = ref();
	 
	const scrollToTop = () => {
		emits("scrollto",'top');
	};
	const scrollToBottom = () => {
		emits("scrollto",'bottom');
	};
	//划动回到顶部
    const toTop = (scrollDiv) => {
        let scrollElem = scrollDiv.value;
        scrollElem.scrollTo({ top: 0, behavior: 'smooth' });
    };
    
	const onStepChange = (scrollDiv) =>{
	    scrollDiv.value.scrollIntoView({
	        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
	        block: "start", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
	        inline: "center", // 定义水平滚动方向的对齐
	    });
	};

	const store = useStore();

	const checkLoggedIn = () => {
		const isAuthenticated = proxy.$cookies.getAuthKey();
		const token = proxy.$cookies.getToken();
		return !!(
			isAuthenticated &&
			token !== undefined &&
			token !== '' &&
			token != null
		);
	};

	const isLoggedIn = ref(checkLoggedIn());

	// console.log(store.state.user.cartList.length,"cart count");
	const isAuthenticated = proxy.$cookies.getAuthKey();
	let cartCount = 0;
	if(isAuthenticated){
		cartCount = store.state.user.cartList.length;
	}
	// 创建一个响应式的对象
	const state = reactive({
	    cartListCount: cartCount,
	    mobile: false,
	    siteInfo: store.state.common.siteInfo?store.state.common.siteInfo:{},
	});
	// console.log(store.state.user.cartList,"cartList");
	const count = ref(0)
	// 监听state.count的变化  
	watch(() => store.state.user.cartList.length, (newValue) => {
	    state.cartListCount = newValue;
	}
	// ,{
	// 	deep:true, //是否开启深度监听    
	// 	immediate: true, //是否立即调用一次 
	// }
	);
	
	const kefuVisible = ref(false);
	const kefuUrl = ref('');
	const kefuMeasuredWidth = ref(0);
	const kefuBox = reactive({
		width: 560,
		height: 720,
		fullscreen: false,
	});

	const getViewportSize = () => {
		const vv = window.visualViewport;
		return {
			width: Math.floor(vv?.width || document.documentElement.clientWidth || window.innerWidth),
			height: Math.floor(vv?.height || document.documentElement.clientHeight || window.innerHeight),
		};
	};

	const calcKefuBox = (contentWidth = 0) => {
		if (contentWidth > 0) {
			kefuMeasuredWidth.value = contentWidth;
		}
		const measured = contentWidth > 0 ? contentWidth : kefuMeasuredWidth.value;
		const { width: vw, height: vh } = getViewportSize();
		const pad = 24;
		const maxW = Math.max(280, vw - pad);
		const maxH = Math.max(320, vh - pad);
		if (vw <= 900) {
			kefuBox.fullscreen = true;
			kefuBox.width = vw;
			kefuBox.height = vh;
			return;
		}
		kefuBox.fullscreen = false;
		const preferred = measured > 0
			? measured + 40
			: Math.min(640, Math.max(560, Math.round(vw * 0.42)));
		kefuBox.width = Math.min(maxW, Math.max(520, preferred));
		kefuBox.height = Math.min(maxH, Math.max(620, Math.round(vh * 0.9)));
	};

	const kefuDialogStyle = computed(() => {
		if (kefuBox.fullscreen) {
			return {
				width: kefuBox.width + 'px',
				height: kefuBox.height + 'px',
				top: '0px',
				right: '0px',
				bottom: '0px',
				left: '0px',
			};
		}
		return {
			width: kefuBox.width + 'px',
			height: kefuBox.height + 'px',
			right: '12px',
			bottom: '12px',
			top: 'auto',
			left: 'auto',
		};
	});

	const measureKefuFrame = (iframe) => {
		try {
			const doc = iframe.contentDocument;
			if (!doc) return false;
			const w = Math.max(
				doc.documentElement?.scrollWidth || 0,
				doc.body?.scrollWidth || 0
			);
			if (w >= 320) {
				calcKefuBox(w);
			}
			if (!doc.getElementById('qdpic-kefu-fit')) {
				const style = doc.createElement('style');
				style.id = 'qdpic-kefu-fit';
				style.textContent = 'html,body{margin:0!important;min-width:0!important;}';
				doc.head?.appendChild(style);
			}
			return true;
		} catch (e) {
			return false;
		}
	};

	const onKefuFrameLoad = (event) => {
		const iframe = event.target;
		if (!measureKefuFrame(iframe)) {
			calcKefuBox(560);
			return;
		}
		setTimeout(() => measureKefuFrame(iframe), 300);
		setTimeout(() => measureKefuFrame(iframe), 1200);
	};

	const closeKefu = () => {
		kefuVisible.value = false;
		kefuMeasuredWidth.value = 0;
		document.body.style.overflow = '';
	};

	const onEscKefu = (event) => {
		if (event.key === 'Escape' && kefuVisible.value) {
			closeKefu();
		}
	};

	const onKefuResize = () => {
		if (kefuVisible.value) {
			calcKefuBox();
		}
	};

	onMounted(async () => {
		if(Object.keys(state.siteInfo).length<=0){
			store.dispatch("common/fetchSiteInfo").then((res) => {
	            state.siteInfo = res
	            console.log(res,"site-info");
	        }).catch(err => {
	            console.error(err)
	        })
		}
		window.addEventListener('keydown', onEscKefu);
		window.addEventListener('resize', onKefuResize);
		window.visualViewport?.addEventListener('resize', onKefuResize);
	});

	onBeforeUnmount(() => {
		window.removeEventListener('keydown', onEscKefu);
		window.removeEventListener('resize', onKefuResize);
		window.visualViewport?.removeEventListener('resize', onKefuResize);
		document.body.style.overflow = '';
	});

	const openLogin = () => {
		sessionStorage.setItem('redirectPath', route.fullPath);
		bus.emit('showLoginDialog', true);
		bus.emit('showLoginDialogMobile', false);
		bus.emit('showLoginDialogQrcode', false);
		bus.emit('showLoginDialogLogin', true);
	};

	const toCart = () => {
		if(undefined === proxy.$cookies.getToken()){
			openLogin();
		} else {
			router.push('/my/cart');
		}
	}

	const openMessage = function() {
		const url = state.siteInfo.kefu;
		if (!url) {
			ElMessage({
				message: proxy.$t('onlineService'),
				grouping: true,
				type: 'warning',
			});
			return;
		}
		kefuUrl.value = url;
		calcKefuBox();
		kefuVisible.value = true;
		document.body.style.overflow = 'hidden';
	}

</script>
<style scoped>
	.component-container {
		position:fixed;
		top:50%;
		right:50px;
		transform:translateY(-50%);
		padding:10px;
		z-index:999;
		display:flex;
		flex-direction: column;

	}
	@media screen and (max-width: 890px) {
		.component-container {
			top: 90%;
			right: 5px;
			transform:translateY(-96%);
		}
	}
	@media screen and (max-width: 767px) {
		.component-container {
			top: 90%;
			right: 5px;
			transform:translateY(-96%);
		}
	}
	.login-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px 5px;
		margin-bottom: 10px;
		color: #000;
		cursor: pointer;
	}
	.login-wrapper:hover {
		color: #111;
	}
	.cart-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		color: white;
		background-color: rgba(215,0,15,1.0);
		/*background-color: rgba(0,49,97,1.0);*/
		position: relative;

	}
	.cart-wrapper:hover{
		cursor:pointer;
	}
	.cart-wrapper .count {
		position: absolute;
		top: -3px;
		right: -3px;
		width: 20px;
		height: 20px;
		/*padding:5px;*/
		border-radius: 10px;
		color: rgba(215,0,15,1.0);
		background-color: rgb(239,239,239); 
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.text {
		writing-mode:vertical-rl;
		padding-top:5px;
		font-size:14px;
		font-weight: bold;
		/*word-break: break-all;*/
	}
	@media screen and (max-width: 768px) {
		.text {
			display:none;
		}
	}
	.totop, .tobottom{
		margin-top:20px;
		background-color:rgb(239,239,239);
		display:flex;
		flex-direction: column;
		align-items: center;
		padding:5px 0;
	}
	.tobottom{
		margin-top:0px;
	}
	.totop:hover,.tobottom:hover{
		cursor:pointer;
	}
	.icon-fanhuidingbu, .icon-huidaodibu, .mykefu {
		display: flex;
		justify-content: center;
		align-items: center;
		padding:10px;
		font-weight: bold;

	}
	.kefu {
		margin-top:20px;
		background-color: rgba(215,0,15,1.0);
	}
	.mykefu {
		/*color:white;*/
		padding:10px 10px 2px 10px;
		font-size:24px;
		font-weight: normal;
	}
	
</style>
<style>
	.kefu-mask {
		position: fixed;
		inset: 0;
		z-index: 20000;
		background: rgba(0, 0, 0, 0.28);
	}
	.kefu-dialog {
		position: fixed;
		background: #fff;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		box-shadow: 0 8px 28px rgba(0, 0, 0, 0.18);
		z-index: 20001;
	}
	.kefu-dialog.is-full {
		box-shadow: none;
	}
	.kefu-dialog__hd {
		flex: 0 0 48px;
		height: 48px;
		padding: 0 12px 0 16px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid #eee;
		font-size: 16px;
		color: #333;
	}
	.kefu-dialog__close {
		border: 0;
		background: transparent;
		cursor: pointer;
		padding: 4px 8px;
		font-size: 18px;
		color: #666;
		line-height: 1;
	}
	.kefu-dialog__frame {
		flex: 1 1 auto;
		width: 100%;
		height: 100%;
		min-height: 0;
		border: 0;
		background: #fff;
	}
</style>